$(document).ready(function() {
  
  let popupAgeValidator = sessionStorage.getItem("plus18");
  if(popupAgeValidator == null){
    $("#popup-age").removeClass("d-none");
  }

  cartCount()
  
});

function cartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      const products = cartData.items; // Array com os produtos no carrinho

      // Soma a quantidade de todos os itens no carrinho, exceto o item com id 41391482994765
      const itemCount = products.reduce((total, product) => {
        return product.id === 41391482994765 ? total : total + product.quantity;
      }, 0);

      // Verifica se a contagem é menor que 6
      /*if (itemCount < 6) {
        $("#min6").removeClass("d-none");
        $("#min6CartPage").removeClass("d-none");
        $(".cart__checkout-button").attr("disabled", true);
      } else {
        $("#min6").addClass("d-none");
        $("#min6CartPage").addClass("d-none");

        if (itemCount > 6 && itemCount % 3 !== 0) {
          $(".cart__checkout-button").attr("disabled", true);
          $("#notMultipleOf3").removeClass("d-none").text(`Adicione mais ${3 - (itemCount % 3)} item(s) para continuar.`);
          $("#notMultipleOf3CartPage").removeClass("d-none").text(`Adicione mais ${3 - (itemCount % 3)} item(s) para continuar.`);
        } else {
          $(".cart__checkout-button").removeAttr("disabled");
          $("#notMultipleOf3CartPage").addClass("d-none");
          $("#notMultipleOf3").addClass("d-none");
        }
      }*/
    })
    .catch(error => {
      console.error("Erro ao obter dados do carrinho:", error);
    });
}



function popupAgeClick(data){
  let ageValue = $(data).val();

  if(ageValue == "plus18"){
    sessionStorage.setItem("plus18", true);
    $("#popup-age").addClass("d-none");
  }else{
    $(".txtLess18").removeClass("d-none")
  }
}

function openModalGallery(data){
  let src_clicked_img = $(data).parent().parent().parent().find(".gallery-img").attr("src");
  let parent = $(data).parent().parent().parent().parent().parent().parent();
  let index = $(parent).find(".modal-gallery").attr("data-index");
  let parent_imgs = $(parent).find(".imgs_list")
  let images = parent_imgs.val().replace(/<[^>]+>/g, '');
  let images_array = images.split(",");
  
  for (var i = 0; i < images_array.length; i++) {
    
    var activeClass = (src_clicked_img == images_array[i]) ? 'active' : '';
    var carouselItem = $('<div class="carousel-item ' + activeClass + '">');
    var image = $('<img class="carousel-img d-block w-100"/>').attr('src', images_array[i]);
    carouselItem.append(image);
    $('.carousel-inner').append(carouselItem);
  }
  
  $(parent).find('#modalGallery-'+index).modal('show')
  $(parent).find('#carouselExampleControls-'+index).carousel();
  $(parent).find(".overlay-modal").css("opacity","1")

}

function closeModal(data){

  let parent = $(data).parent().parent().parent().parent().parent();

  $(parent).find('.modal-gallery').modal('hide')
  $('.carousel .carousel-inner .carousel-item').remove();
  $(parent).find(".overlay-modal").css("opacity","0");
}

